import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AxiosAdapter from './AxiosAdapter';
import axios from 'axios';

import {
  HTTP_GETTYPE,
  MSG_TIMEOUT_REQUEST,
  TIMEOUT_DEFAULT,
  STATUS_API
} from '../app/constant/config';
import { MESSAGE } from 'src/app/constant/message';

export const getListCustomer = AxiosAdapter.GetHttp(
  'customerSlice/getlistCustomer',
  '/agencies/statistic/devices/user',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createCustomer = AxiosAdapter.HttpPost(
  'customerSlice/createCustomer',
  '/agencies/create/enduser',
  MESSAGE.CREATE_AGENCY_SUCCESS,
  'Tạo mới khách hàng thất bại'
);

export const customerSlice = createSlice({
  name: 'customerSlice',
  initialState: {
    listCustomer: [],
    totalCustomer: 0,
    error: null,
    statusGet: null,
    statusCreate: null,
    isLoading: false
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.statusCreate = null;
      state.isLoading = false;
      state.error = null;
    }
  },

  extraReducers: {
    [getListCustomer.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListCustomer.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listCustomer = action.payload.payload;
      state.totalCustomer = action.payload.numberOfItems;
      state.isLoading = false;
    },
    [getListCustomer.rejected]: (state, action) => {
      state.statusGetAllAgencies = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createCustomer.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createCustomer.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createCustomer.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    }
  }
});

export const { resetChange } = customerSlice.actions;

export default customerSlice.reducer;
